var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoldHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    rx: 2,
    fill: "#DFE7C1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.98828 14.4V3.59998H9.26234C10.1005 3.59998 10.8727 3.85823 11.5789 4.37473C12.2852 4.89135 12.6383 5.6081 12.6383 6.52498C12.6383 7.16248 12.4977 7.65935 12.2164 8.0156C11.9352 8.37185 11.6695 8.63148 11.4195 8.79448C11.7445 8.94398 12.0945 9.21248 12.4695 9.59998C12.8445 9.98748 13.032 10.5562 13.032 11.3062C13.032 12.4437 12.6131 13.2437 11.7752 13.7062C10.9373 14.1687 10.151 14.4 9.41628 14.4H4.98828ZM7.36953 12.1875H9.33228C9.93628 12.1875 10.3008 12.0344 10.4258 11.7281C10.5508 11.4219 10.6133 11.2 10.6133 11.0625C10.6133 10.925 10.5477 10.7031 10.4164 10.3969C10.2852 10.0906 9.90078 9.93748 9.26328 9.93748H7.36953V12.1875ZM7.36953 7.83748H9.11328C9.52578 7.83748 9.82891 7.7281 10.0227 7.50935C10.2164 7.2906 10.3133 7.05623 10.3133 6.80623C10.3133 6.50623 10.2063 6.26248 9.99247 6.07498C9.77859 5.88748 9.50184 5.79373 9.16222 5.79373H7.36953V7.83748Z",
    fill: "#2D3245"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoldHover);
export default __webpack_public_path__ + "static/media/Bold-Hover.f59dd65c51842df2e587a9d31ef2c5e8.svg";
export { ForwardRef as ReactComponent };